export default __webpack_public_path__ + "static/media/guide1.87325a78.png";